import LicencePage from "./LicencePage";

export default LicencePage;
